module.exports = __webpack_public_path__ + "static/img/echo_tape.80e677b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls37-1/echo_tape.png
// module id = LS8f
// module chunks = 12